import {DatePeriodEnum} from '../../../util/date';

import {
    ReviewsAndAnswersFilterQueriesEnum,
    ReviewsAndAnswersFilterStateType,
    ReviewsAndAnswersReviewFiltersType,
} from './reviews-and-answers-statistics-filter-type';

export const defaultReviewFilters: ReviewsAndAnswersReviewFiltersType = {
    [ReviewsAndAnswersFilterQueriesEnum.CatalogIds]: [],
    [ReviewsAndAnswersFilterQueriesEnum.Sentiments]: [],
    [ReviewsAndAnswersFilterQueriesEnum.TagIds]: [],
    [ReviewsAndAnswersFilterQueriesEnum.Rating]: [],
    [ReviewsAndAnswersFilterQueriesEnum.WithoutText]: '',
    [ReviewsAndAnswersFilterQueriesEnum.IsReplied]: '',
    [ReviewsAndAnswersFilterQueriesEnum.ActionReply]: '',
    [ReviewsAndAnswersFilterQueriesEnum.Target]: '',
    // Deleted reviews are excluded by default (sends in_trash=false).
    [ReviewsAndAnswersFilterQueriesEnum.IncludeDeleted]: false,
};

// Feature-off defaults: no review filters. Two variants by how a widget treats deleted
// reviews per the widget spec — deleted counted (in_trash=true).
export const legacyReviewFilters: ReviewsAndAnswersReviewFiltersType = {
    ...defaultReviewFilters,
    [ReviewsAndAnswersFilterQueriesEnum.IncludeDeleted]: true,
};

// Feature-off default for widgets that don't count deleted reviews (by_rating, sentiments,
// avg_ratings_by_day, tags) — deleted excluded (in_trash=false).
export const legacyReviewFiltersWithoutDeleted: ReviewsAndAnswersReviewFiltersType = {
    ...defaultReviewFilters,
    [ReviewsAndAnswersFilterQueriesEnum.IncludeDeleted]: false,
};

export const defaultFilterState: ReviewsAndAnswersFilterStateType = {
    [ReviewsAndAnswersFilterQueriesEnum.PeriodStart]: new Date(),
    [ReviewsAndAnswersFilterQueriesEnum.PeriodEnd]: new Date(),
    [ReviewsAndAnswersFilterQueriesEnum.Period]: DatePeriodEnum.Month,
    [ReviewsAndAnswersFilterQueriesEnum.CompareMode]: null,
    [ReviewsAndAnswersFilterQueriesEnum.ComparePeriodStart]: null,
    [ReviewsAndAnswersFilterQueriesEnum.ComparePeriodEnd]: null,
    ...defaultReviewFilters,
};
